import React, { useMemo } from "react";
import { RedIndicator } from "./indicators/RedIndicator";
import { YellowIndicator } from "./indicators/YellowIndicator";
import { GreenIndicator } from "./indicators/GreenIndicator";
import { BlueIndicator } from "./indicators/BlueIndicator";
import { GrayIndicator } from "./indicators/GrayIndicator";
import { BlackIndicator } from "./indicators/BlackIndicator";

export enum LedIndicatorColor {
  GRAY = 0,
  RED = 1,
  YELLOW = 2,
  GREEN = 3,
  BLUE = 4,
  BLACK = 5,
}

export interface LedIndicatorProps {
  color: LedIndicatorColor;
  scale: number;
}

export const LedIndicator = ({ color, scale }: LedIndicatorProps) => {
  const IndicatorClass = useMemo(() => {
    switch (color) {
      case LedIndicatorColor.RED:
        return RedIndicator;
      case LedIndicatorColor.YELLOW:
        return YellowIndicator;
      case LedIndicatorColor.GREEN:
        return GreenIndicator;
      case LedIndicatorColor.BLUE:
        return BlueIndicator;
      case LedIndicatorColor.GRAY:
        return GrayIndicator;
      case LedIndicatorColor.BLACK:
        return BlackIndicator;
    }
  }, [color]);
  return <IndicatorClass scale={scale} />;
};
